import gql from 'graphql-tag';

import credentialFragment from '../fragments/credentialFragment';

export const queryCredentials = gql`
  query credentials {
    credentials {
      ...credentialFragment
    }
  }
  ${credentialFragment}
`;
export default queryCredentials;
